import "./src/styles/global.css"
import "./src/styles/custom.css";
import React from "react";
import { isSentryEnabled } from "./src/config/sentry";

let Sentry = null;

if (isSentryEnabled) {
  Sentry = require("@sentry/gatsby");

  // Initialise Sentry in the browser bundle.
  // gatsby-browser.js is guaranteed to run client-side only.
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN || "https://9c53689a00f5e04fec34231456d1cf62@o4511030216228864.ingest.us.sentry.io/4511030290022400",
    environment: process.env.NODE_ENV || "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
    tracePropagationTargets: [
      "localhost",
      /^http:\/\/localhost:1337/,
      /^https:\/\/strapi\.zusedigital\.com/,
      /^https:\/\/stagingstrapi\.zusedigital\.com/,
      /^https:\/\/admin\.zusedigital\.com/,
      /^https:\/\/stagingadmin\.zusedigital\.com/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: true,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      /^Script error\.$/,
      "Non-Error promise rejection captured",
      /^Validation failed on .* form$/,
      "ValidationError",
    ],
    beforeSend(event) {
      if (event.tags?.error_type === "validation") return null;
      const type = event.exception?.values?.[0]?.type;
      if (type === "ValidationError") return null;
      return event;
    },
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /safari-extension:/i,
    ],
    sendDefaultPii: true,
    enableLogs: true,
  });
}

// Wrap the entire app in Sentry's ErrorBoundary when enabled.
export const wrapRootElement = ({ element }) => {
  if (!isSentryEnabled || !Sentry) {
    return element;
  }

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Something went wrong. Our team has been notified.</p>
        </div>
      }
      showDialog={false}
    >
      {element}
    </Sentry.ErrorBoundary>
  );
};

export const onRouteUpdate = ({ location }) => {
  const path = location.pathname.replace(/\/$/, "") || "/";
  document.body.classList.remove("home_v2", "home_v3");
  if (path === "/home-v2") document.body.classList.add("home_v2");
  if (path === "/home-v3") document.body.classList.add("home_v3");
  if (path !== "/home-v3") document.documentElement.classList.remove("home-v3-ready");

  if (!location.hash) {
    window.scrollTo(0, 0);
  }
  wrapCodeElements();

  if (typeof window.clarity === "function") {
    window.clarity("set", "page", location.pathname);
  }
};

export const onInitialClientRender = () => {
  const path = window.location.pathname.replace(/\/$/, "") || "/";
  document.body.classList.remove("home_v2", "home_v3");
  if (path === "/home-v2") document.body.classList.add("home_v2");
  if (path === "/home-v3") document.body.classList.add("home_v3");

  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });
};

const wrapCodeElements = () => {
  document.querySelectorAll("code").forEach((codeEl) => {
    if (!codeEl.parentElement.classList.contains("blog-code-block-parent")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("blog-code-block-parent");

      codeEl.parentNode.insertBefore(wrapper, codeEl);
      wrapper.appendChild(codeEl);
    }
  });
};
